<template>
    <div id="homeBox">
        <div class="flexcenter" id="flexcenter">
            <!-- 搜索区域-->
            <div style="margin-right: 20px">
                <span class="titlew" >日期：</span>
                <el-date-picker
                        v-model="searchDate"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                >
                </el-date-picker>

                <span class="titlew" >下单时间：</span>
                <el-date-picker
                        size="mini" style="width:200px"
                        v-model="searchStartTime"
                        type="datetime"
                        :picker-options="dateLimit"
                        placeholder="开始时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @blur="startChange"
                        clearable
                >
                </el-date-picker>
                <span class="titlew">至</span>
                <el-date-picker size="mini" style="width: 200px; margin-right:15px; "
                                v-model="searchEndTime"
                                type="datetime"
                                :picker-options="dateLimit"
                                clearable
                                placeholder="结束时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                @blur="endChange"
                >
                </el-date-picker>
                <!--食堂下拉               -->
                <span class="titlew">食堂:</span>
                <el-select
                        size="mini"
                        style="width: 200px ; margin-right:10px;margin-left: 5px"
                        clearable class="input-width"
                        v-model="searchCanteen"
                        filterable>
                    <el-option
                            v-for="item in canteenData"
                            :key="item.canteen"
                            :label="item.canteenName"
                            :value="item.canteen">
                    </el-option>
                </el-select>

                <span class="titlew">订单状态:</span>
                <el-select
                        size="mini"
                        style="width: 200px ; margin-right:10px;margin-left: 5px"
                        clearable class="input-width"
                        v-model="searchOrderState"
                        filterable>
                    <el-option
                            v-for="item in stateData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
                <!-- 搜索框 -->
                <el-input
                        size="mini"
                        style="width: 200px  "
                        placeholder="请输入搜索内容"
                        v-model="searchData"
                        clearable>
                </el-input>
                <!-- 搜索按钮 -->
                <el-button  class="mrl15 " icon="el-icon-search" circle  @click="Search" size="mini"></el-button>
            </div>

        </div>
        <!--  父表格  -->
        <el-table
                id="eltable"
                ref="ftable"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                style="width: 100%"
                row-key="orderId"
                stripe
                border
                :header-cell-style="{background:'#eef1f6',color:'black',}"
                :header-row-style="{height:'50px'}"
                :highlight-current-row="true"
                @expand-change="dddd"
        >
            <el-table-column type="expand"  ref="tree">

                <!--   子表   -->
                <template slot-scope="scope" width="1">
                    <el-table
                            ref="table"
                            size="mini"
                            border
                            :data="scope.row.manageChildListDtoList"
                            :header-cell-style="{background:'#F0FFFF',color:'#000',}"
                    >
                        <el-table-column
                                type="index"
                                label="序号"
                                align="center"
                                width="190px"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="foodName"
                                label="菜品名称"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="stateName"
                                label="状态"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="price"
                                label="价格(元)"
                                align="center"
                                width="350"
                                show-overflow-tooltip>

                        </el-table-column>
                        <el-table-column
                            prop="num"
                            label="数量(份)"
                            align="center"
                            width="350"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="cancelTime"
                                label="取消订单时间"
                                align="center"
                                width="350"
                                show-overflow-tooltip
                        >
                        </el-table-column>
<!--                        <el-table-column-->
<!--                                width="130"-->
<!--                                label="操作">-->
<!--                            <template slot-scope="scope" >-->
<!--                                <div >-->
<!--                                    <el-button  type="text" size="mini" @click="refund(scope.row)">退款</el-button>-->
<!--&lt;!&ndash;                                    <el-button style="color:red;" type="text" size="mini" @click="delson(scope.row,scope.$index)">删除</el-button>&ndash;&gt;-->
<!--                                </div>-->
<!--                            </template>-->
<!--                        </el-table-column>-->

                    </el-table>
                </template>
                <!--   子表   -->

            </el-table-column>
            <el-table-column
                    type="index"
                    label="序号"
            >
            </el-table-column>
            <el-table-column
                    prop="code"
                    :label="$t('form_order_number')"
                    show-overflow-tooltip
            >
            </el-table-column>

<!--            <el-table-column-->
<!--                    prop="ICId"-->
<!--                    label="IC卡号"-->
<!--                    show-overflow-tooltip-->
<!--            >-->
<!--            </el-table-column>-->
            <el-table-column
                    prop="uName"
                    label="姓名"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="phone"
                    label="联系方式"
                    show-overflow-tooltip
            >
            </el-table-column>
<!--            <el-table-column-->
<!--                    prop="division"-->
<!--                    label="部门"-->
<!--                    show-overflow-tooltip-->
<!--            >-->
<!--            </el-table-column>-->
            <el-table-column
                    label="餐别"
                    prop="cateringName"
                    width="70px"
                    show-overflow-tooltip
            >
<!--                <template slot-scope="scope" >-->
<!--                    <div >-->
<!--                        <span v-if="scope.row.type==1">早餐</span>-->
<!--                        <span v-if="scope.row.type==2">午餐</span>-->
<!--                        <span v-if="scope.row.type==3">晚餐</span>-->
<!--                        <span v-if="scope.row.type==4">夜宵</span>-->
<!--                    </div>-->

<!--                </template>-->
            </el-table-column>
            <el-table-column
                    :label="$t('form_date')"
                    prop="date"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    label="食堂名称"
                    prop="canteenName"
                    show-overflow-tooltip
            >
<!--                <template slot-scope="scope" >-->
<!--                    <div >-->
<!--                        <span v-if="scope.row.canteen==1">西区食堂</span>-->
<!--                        <span v-if="scope.row.canteen==2">东区食堂</span>-->
<!--                        <span v-if="scope.row.canteen==3">岳达食堂</span>-->
<!--                    </div>-->

<!--                </template>-->
            </el-table-column>
            <el-table-column
                    label="餐别"
                    prop="cateringName"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    label="订单状态"
                    prop="stateName"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    label="就餐类型"
                    width="70px"
                    show-overflow-tooltip
            >
                <template slot-scope="scope" >
                    <div >
                        <span v-if="scope.row.type==1">自提</span>
                        <span v-if="scope.row.type==2">堂食</span>
                    </div>

                </template>
            </el-table-column>
<!--            <el-table-column-->
<!--                    label="订单状态"-->
<!--                    width="70px"-->
<!--                    show-overflow-tooltip-->
<!--            >-->
<!--                <template slot-scope="scope" >-->
<!--                    <div >-->
<!--                        <span v-if="scope.row.orderState==0">待使用</span>-->
<!--                        <span v-if="scope.row.orderState==1">已消费</span>-->
<!--                        <span v-if="scope.row.orderState==2">已评价</span>-->
<!--                        <span v-if="scope.row.orderState==3">已过期</span>-->
<!--                        <span v-if="scope.row.orderState==4">已取消(用户)</span>-->
<!--                        <span v-if="scope.row.orderState==5">已取消(系统)</span>-->
<!--                    </div>-->

<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column
                    prop="totalMoney"
                    label="付款金额"
                    show-overflow-tooltip
            >
            </el-table-column>

            <el-table-column
                    label="支付方式"
                    show-overflow-tooltip
            >
                <template slot-scope="scope" >
                    <span >余额支付</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    label="下单时间"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    label="就餐时间"
                    prop="mealTime"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    width="170"
                    label="操作">
                <template slot-scope="scope" >
                    <div>
                        <el-button  type="text" size="mini" @click="editDish(scope.row)">退款</el-button>
                    </div>

                </template>
            </el-table-column>
<!--            <el-table-column-->
<!--                    width="70"-->
<!--                    label="操作">-->
<!--                <template slot-scope="scope" >-->
<!--                    <div >-->
<!--                        <el-button  type="text" size="mini" @click="refundFu(scope.row)">退款</el-button>-->
<!--&lt;!&ndash;                        <el-button  style="color:red;"  type="text" size="mini" @click="del(scope.$index)">作废</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;                        <el-button    type="text" size="mini" @click="addson(scope.row,scope.$index)">新增流程</el-button>&ndash;&gt;-->
<!--                        &lt;!&ndash;                        <el-button v-if="scope.row.dcsNum!==0"   type="text" size="mini" @click="seedetail(scope.row)">{{scope.row.see==1?'收起':'查看'}}</el-button>&ndash;&gt;-->
<!--                    </div>-->
<!--                </template>-->
<!--            </el-table-column>-->
        </el-table>
        <!-- 父表格 -->

        <!-- 分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother  fl">
                    <!--
                    small：是否使用小型分页样式
                    page-size:每页显示的条目数
                    page-sizes：每页显示个数选择器的选项设置
                    total：总条目数
                    current-page：当前页数，支持 .sync 修饰符
                    layout：组件布局，子组件名用逗号分隔

                    size-change：pageSize改变时会触发  回调参数为每页条数
                    current-change：currentPage 改变时会触发  回调参数为当前页
                    -->
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10,20,30,40]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <!--
                    small：是否使用小型分页器
                    page-size:每页显示的条目数
                    page-sizes：每页显示个数选择器的选项设置
                    total：条目总数
                    current-page：当前页数，支持 .sync 修饰符
                    layout：组件布局，子组件名用逗号分隔

                    size-change：pageSize改变时会触发  回调参数为每页条数
                    current-change：currentPage 改变时会触发  回调参数为当前页
                    -->

                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :pager-count="5"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">

                    </el-pagination>
                </div>

            </div>
        </div>
        <!-- 分页器-->

        <!--  弹窗  -->
        <!--  新增流程弹窗(子)  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                top="100px"
                width="500px"
                height="300"
                :title="title"
                :visible.sync="flowPath"
                v-if="flowPath"
        >
            <!--            <addson  @list="list" :editData="editData" @close="close"></addson>-->
            <refundNumber  @close="close"></refundNumber>
        </el-dialog>

        <!--  弹窗  -->
        <!--  退款弹窗(父)  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="refundFuDia"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="refundFuDia"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">{{deldetail}}</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="refundFuDia = false">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="submitRefund">确 定</el-button>
  </span>
        </el-dialog>

        <!--  弹窗  -->
        <!--  删除流程弹窗(子)  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delsonDialog"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delsonDialog"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">{{deldetail}}</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="delsonDialog = false">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="submitsondel">确 定</el-button>
  </span>
        </el-dialog>
        <!--  弹窗  -->
    </div>
</template>

<script>
    import {baseerp} from "@/utils/baseUrl";
    import * as API from "./api";
    import {mapActions} from "vuex";

    // import refundNumber from "./component/refundNumber";

    export default {
        name: "orderManagement",
        components:{
            // refundNumber,
        },

        data(){
            return{
                searchDate:'',
                searchStartTime:'',
                searchEndTime:'',
                lineList:{},
                procedureList:{},
                lineIndex:'',
                sonIndex:"",
                fno:'',
                addData:{},
                searchCanteen:'',
                searchOrderState:'',
                refundFuDia:false,
                refundamount:0,
                delsonDialog:false,
                flowPath:false,
                see:false,
                maps:new Map(),
                childrenlist:[],
                loading:'',
                editData:{},
                productLines:false,//编辑弹窗
                currentPage:1,
                canteenData:[],
                stateData:[
                    {
                    'id':0,
                    'name':'待付款'
                    },
                    {
                        'id':1,
                        'name':'支付超时'
                    },
                    {
                        'id':2,
                        'name':'待使用'
                    },
                    {
                        'id':3,
                        'name':'待评价'
                    },
                    {
                        'id':4,
                        'name':'已使用'
                    },
                    {
                        'id':5,
                        'name':'已评价'
                    },
                    {
                        'id':6,
                        'name':'已取消(用户)'
                    },
                    {
                        'id':7,
                        'name':'已取消(管理员)'
                    },
                    {
                        'id':8,
                        'name':'已过期'
                    },
                    {
                        'id':9,
                        'name':'已退款'
                    },
                    {
                        'id':10,
                        'name':'部分退款'
                    }

                ],
                searchData:'',
                pageSize:10,
                deldetail:'',
                total:0,
                dateLimit: {
                    disabledDate: (time) => {
                        var now = new Date(); // 当前日期
                        var nowDayOfWeek = now.getDay(); // 今天本周的第几天
                        var nowDay = now.getDate();    // 当日
                        var nowMonth = now.getMonth(); // 当前月
                        var nowYear = now.getYear();   // 当前年
                        nowYear += (nowYear < 2000) ? 1900 : 0;
                        var weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek) + 8);
                        return time.getTime() >  weekEndDate//禁用下周之后的所有日期
                    }
                },
                listid:0,
                baseerp:'',
                tableData: [
                    // {orderId:202308231200101,ICId:3624453821,name:"张三",contact:"13835443678",division:"安全部",type:2,canteen:1,diningType:2,
                    //     orderState:0,payment:8,dishEvaluation:0,textEvaluation:"无",filePath:[],
                    //     orderTime:"2023-8-23 12:00", startTime:"2023-8-24 12:03",endTime:"2023-8-31 12:03",dinnerTime:"2023-8-24 12:03",
                    //     evaluationTime:"2023-8-24 15:03",
                    //     child:[
                    //         {dishName:"鱼香肉丝",price:5,num:1,total:5},
                    //         {dishName:"土豆丝",price:2,num:1,total:2},
                    //         {dishName:"花卷",price:0.5,num:2,total:1},
                    //     ]},
                    // {orderId:202308231200643,ICId:3624453758,name:"李四",contact:"13335443684",division:"环保部",type:2,canteen:2,diningType:2,
                    //     orderState:1,payment:8,dishEvaluation:5,textEvaluation:"不错，很好吃",filePath:["n.sinaimg.cn/front/779/w2048h2731/20181208/w3Ut-hprknvt8386137.jpg",
                    //         "n.sinaimg.cn/front/779/w2048h2731/20181208/w3Ut-hprknvt8386137.jpg",
                    //         "n.sinaimg.cn/front/779/w2048h2731/20181208/w3Ut-hprknvt8386137.jpg",
                    //     ],
                    //     orderTime:"2023-8-23 12:10", startTime:"2023-8-24 12:03",endTime:"2023-8-31 12:03",dinnerTime:"2023-8-24 12:03",
                    //     evaluationTime:"2023-8-24 15:03",
                    //     child:[
                    //         {dishName:"酸梅小排",price:5,num:1,total:5},
                    //         {dishName:"白菜炖豆腐",price:2,num:1,total:2},
                    //         {dishName:"米饭",price:1,num:1,total:1},
                    //     ]},
                    // {orderId:202308231200437,ICId:3624453986,name:"王五",contact:"13835443427",division:"电仪智控部",type:2,canteen:2,diningType:1,
                    //     orderState:3,payment:9,dishEvaluation:0,textEvaluation:"无",filePath:[],
                    //     orderTime:"2023-8-23 12:10", startTime:"2023-8-24 12:03",endTime:"2023-8-31 12:03",dinnerTime:"2023-8-24 15:03",
                    //     evaluationTime:"2023-8-24 15:03",
                    //     child:[
                    //         {dishName:"炸虾仁",price:6,num:1,total:6},
                    //         {dishName:"土豆丝",price:2,num:1,total:2},
                    //         {dishName:"米饭",price:1,num:1,total:1},
                    //     ]},
                ],
                search:'',
                tableHeight:0,//列表高度
                consumername:[],//消费名字数据
                title:'',
                delDialogVisible:false//删除弹框
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.getCanteenList()
            // this.total = this.tableData.length
            this.$nextTick(()=>{
                this.onResize();

            })
            this.getList()
            // this.$refs.ftable.toggleRowExpansion(item,false)
            //公共样式
            this.baseerp=baseerp
            // this.dcslist()
            // this.$nextTick(function () {
            //     this.heightAuto();
            // window.addEventListener('resize',this.onResize);

            // });

        },

        beforeDestroy() {
            // window.removeEventListener('resize',this.heightAuto)
        },
        methods:{
            //食堂下拉
            async getCanteenList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                }
                let res = await API.getCanteenList(params);
                if (res.code == 1) {
                    this.canteenData=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            startChange(){
                if(this.searchEndTime!=''){
                    if(this.searchEndTime<this.searchStartTime){
                        this.searchStartTime=''
                        this.$message.error('请选择小于或等于结束时间的值')
                    }
                }
            },
            endChange(){
                if(!this.searchStartTime && this.searchEndTime){
                    this.searchEndTime=''
                    this.$message.error('请先选择开始时间')
                }
                if(this.searchEndTime&&this.searchEndTime<this.searchStartTime){
                    this.searchEndTime=''
                    this.$message.error('请选择大于或等于开始时间的值')
                }
            },

            clist(){
                this.tableData.forEach(item=>{
                    this.$refs.ftable.toggleRowExpansion(item,false)

                })
                // this.$refs.ftable.toggleRowExpansion(item,false)

            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            ...mapActions(["getCurrentMenuId"]),
            //高度

            heightAuto(){
                this.tableHeight = window.innerHeight - document.getElementById('body').getBoundingClientRect().top -48 -36;

            },

            //关闭弹框
            close(){
                this.flowPath=false
                this.productLines=false
            },
            //页面搜索
            Search(){
                if(!this.searchStartTime&&!this.searchEndTime){
                    this.getList()
                }else if(!this.searchEndTime){
                    this.$message.error('请选择结束时间')
                }else if (!this.searchStartTime){
                    this.$message.error('请选择开始时间')
                }else {
                    this.getList()
                }
                this.currentPage=1
            },
            //分页
            //监听pagesize改变的事件
            handleSizeChange(newsize) {
                //console.log(`每页 ${newsize} 条`);
                //最新的条数（newsize）赋值给 动态的 pageSize
                this.pageSize = newsize;    //动态改变

                //获取到最新一页显示的数据  重新发送请求
                //this.clist()
                this.getList()
            },
            // 监听 页码值 改变的数据
            //监听页码值改变的数据
            handleCurrentChange(newPage) {
                // console.log(`当前页: ${newPage}`);
                //把最新的页码（newPage）赋值给 动态的 currentPage
                this.currentPage = newPage;    //动态改变
                //获取到最新页码值  重新发送请求
                //this.clist()
                this.getList()
                //this.dcslist()
            },


            //aaaa
            async getList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    search:this.searchData,
                    startTime:this.searchStartTime,
                    endTime:this.searchEndTime,
                    date:this.searchDate,
                    canteen:this.searchCanteen,
                    state:this.searchOrderState
                }

                let res = await API.getList(params);
                if (res.code == 1) {
                    this.total=res.total
                    this.tableData=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //退款(父)
            refundFu(val){
                // this.lineList = val
                // console.log(val)
                this.refundamount=val.payment
                this.deldetail='是否要退款'
                // this.getServiceConfigDetail()
                this.refundFuDia=true
            },
            //确认退款(父)
            submitRefund(){

                this.refundFuDia=false
            },
            //退款（子）
            refund(value){
                //console.log(value)
                this.title='退款'
                //console.log(this.procedureList)
                //this.listid=e.pid
                // console.log(e)
                // this.editData.pid=e.id
                //this.editData=Object.assign({},e);
                // this.dcsdetail()
                this.flowPath=true
            },


            //作废流程(子)
            delson(val,index){
                this.title='删除'
                //console.log("child数组的"+val.fno,index)
                this.sonIndex=index
                // this.templateUsed()
                this.fno = val.fno
                this.deldetail='是否要删除'
                this.delsonDialog=true
            },
            //流程确认作废(子)
            submitsondel(){
                //this.dcsdelete()
                let index = this.tableData.map((item) => item.no).indexOf(this.fno);
                //console.log(index)
                //console.log(this.tableData[index].child[this.sonIndex])
                this.tableData[index].child.splice(this.sonIndex,1)
                // 1
                // this.tableData.forEach(e=>{
                //     console.log(e)
                //     e.child.splice(this.sonIndex,1)
                // })
                this.delsonDialog=false

            },

            //业务配置列表查询
            // async linelist() {
            //     let result = await this.getCurrentMenuId({path: this.$route.path});
            //     if (result.i_id !== "") {
            //         this.mid = result.i_id
            //         //sessionStorage：将数据保存在浏览器中
            //         //sessionStorage.setItem()：创建sessionStorage，括号内为要保存的数据
            //         //result.i_id:需要保存的数据
            //         //mids：为这些数据创建自定义名称
            //         sessionStorage.setItem('mids', result.i_id)
            //     } else {
            //         this.mid = sessionStorage.getItem('mids')
            //     }
            //     let params = {
            //         search:this.Searchdata,
            //         currentPage: this.currentPage,
            //         pageSize: this.pageSize
            //     }
            //     let res = await API.linelist(params);
            //     //console.log(res)
            //     //let res = await API.dcslist(params);
            //     if (res.code == 1) {
            //         // console.log(this.listid)
            //         this.tableData=res.data.list
            //         this.total=res.data.total
            //         // this.$nextTick(()=>{
            //         this.tableData.forEach(item=>{
            //             item.createTime=item.createTime.substring(0,10)
            //
            //             // console.log(this.$refs.deliverlight.toggleRowExpansion(item,false))
            //
            //
            //
            //         })
            //
            //         // document.getElementsByClassName('.el-icon-arrow-right').
            //         // this.$forceUpdate()
            //         // })
            //         //
            //
            //         // console.log(this.tableData)
            //     } else if (res.code == -2) {
            //         this.$router.push('/login');
            //         this.$message.error(res.message);
            //     } else {
            //         this.$message.error(res.message);
            //     }
            // },
            load(tree,treeNode,resolve){
                // this.loading=i
                this.maps.set(tree.id, {tree, treeNode, resolve});

                // console.log(i,q)
                // setTimeout(()=>{
                //     resolve(
                //         this.childrenlist
                //     )
                // },1000)
            },

            dddd(e,i){
                const isExpend = i.some(r => r.id === e.id) // 判断当前行展开状态
                if (isExpend) {
                    this.listid=e.id
                    // this.list()
                    // this.tableData.forEach(item=>{
                    // if(this.listid!==item.id){
                    // this.$refs.ftable.toggleRowExpansion(item,false)
                    // console.log(this.$refs.deliverlight.toggleRowExpansion(item,false))

                    // }
                    // })
                    // console.log(e,i)

                    // Do some things
                } else {
                    return
                }

            },



        },

    }
</script>

<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: end;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/.el-table__expanded-cell{
        padding: 5px 0px;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width: 53.571rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 42.571rem;*/
        width:90%
    }
    /deep/.el-table__header{
        width: 100% !important;
    }
    /deep/.el-table__body{
        width: 100% !important;

    }
    .left{
        width: 17.857rem;
    }
</style>